import React, { useContext } from 'react';
import { loginUrl, logoutUrl, myProfileUrl, videoChatUrl } from '../../constants/appUrls';

import Auxiliary from '../../hoc/Auxiliary';
import NavigationItem from './NavigationItem';

import AuthContext from '../../contexts/AuthContext';

const NavigationItems = props => {

    const { firstName, isLoggedIn } = useContext(AuthContext);

    return (
        <ul className="navigation-items">
            {isLoggedIn && <Auxiliary>
                <p className="navigation-items__user">Welcome, {firstName}</p>
                <NavigationItem title="Home" pathName='/' className="navigation-item" />
                <NavigationItem title="My Profile" pathName={myProfileUrl} className="navigation-item" />
                <NavigationItem title="New VC" pathName={videoChatUrl} className="button-cta" />
            </Auxiliary>}
            {isLoggedIn
                ? <NavigationItem title="Logout" pathName={logoutUrl} className="button-cta" />
                : <NavigationItem title="Login" pathName={loginUrl} className="button-cta" />}
        </ul>
    );
}

export default NavigationItems;